import { C } from '../../theme/palette';

export function Splash() {
  return (
    <div
      style={{
        height: '100%',
        background: 'linear-gradient(160deg,' + C.navy + ',' + C.navyM + ' 55%, #0E1626)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 16,
          background: C.red,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontWeight: 900,
          fontSize: 30,
          marginBottom: 16,
        }}
      >
        S
      </div>
      <div style={{ fontSize: 34, fontWeight: 900, color: '#fff', letterSpacing: -1 }}>
        SwissTech
      </div>
      <div style={{ fontSize: 11, color: 'rgba(255,255,255,.6)', marginTop: 6 }}>
        Devis · Factures · Comptabilité — Logiciel PME complet
      </div>
      <div
        style={{
          marginTop: 26,
          width: 34,
          height: 34,
          border: '3px solid rgba(255,255,255,.2)',
          borderTopColor: '#fff',
          borderRadius: '50%',
          animation: 'stspin 0.8s linear infinite',
        }}
      />
    </div>
  );
}
